import { createStructuredSelector } from 'reselect';
import { getCarouselData } from '../../CommonComponents/Carousel/selectors';
import { selectAccountID } from '../../selectors/globalSelectors';

/**Financial Advisor State Selector */
const selectFinancialAdvisorStates = (state) => state.financialAdvisorDashboard;

/** Messaging State selector */
const selectMessagingStates = (state) => state.messaging;

/** Advisor Data */
const selectAdvisorData = (state) => {
  const { advisorsData } = selectFinancialAdvisorStates(state);
  return advisorsData;
};

const selectFinancialData = (state) => {
  const { data } = selectAdvisorData(state);
  return data;
};

const selectFinancialDataLoadingStatus = (state) => {
  const { isLoading } = selectAdvisorData(state);
  return isLoading;
};

/** User Data */
const selectUserData = (state) => {
  const { userData } = selectFinancialAdvisorStates(state);
  return userData.data;
};

/** Filter Data */
const selectFilterData = (state) => {
  const { filterData } = selectFinancialAdvisorStates(state);
  return filterData.data;
};

/** Roles */
const selectRoles = (state) => {
  const { roles } = selectFinancialAdvisorStates(state);
  return roles.data;
};

const selectStates = (state) => {
  const { states } = selectFinancialAdvisorStates(state);
  return states.data;
};

/** additionalAccountDetails data */
const selectFinancialAdvisorForAnyAccountStatus = (state) => {
  const { messages } = selectMessagingStates(state);
  return messages.additionalAccountDetails.financialAdvisorForAnyAccount;
};

export const financialAdvisorStates = createStructuredSelector({
  accountID: selectAccountID,
  financialData: selectFinancialData,
  userData: selectUserData,
  filtersAvailable: selectFilterData,
  roles: selectRoles,
  states: selectStates,
  isLoading: selectFinancialDataLoadingStatus,
  carouselData: getCarouselData,
  financialAdviser: selectFinancialAdvisorForAnyAccountStatus,
});
